import React from 'react';
import { Skeleton } from '@mui/material';
import { WorkspaceAPI } from '../../../redux/stoerkID/StoerkIdAPI.model';

function WorkspaceName(props: {
  workspace: WorkspaceAPI | undefined;
  isLoading?: boolean;
}) {
  return (
    <>
      {props.isLoading || !props.workspace ? (
        <Skeleton variant="text" width={80} />
      ) : (
        props.workspace.name
      )}
    </>
  );
}

export default WorkspaceName;
